<template>
    <div @click="changeMode">
        <client-only>
            <v-alert v-if="$breakpoint.smAndDown && visible" class="text-white d-flex flex-nowrap" color="primary">
                <span v-if="mobileButtonInfo">
                    {{ $t('found_offers', count) }}
                </span>
                <div v-else class="d-flex flex-nowrap">
                    {{ $t('delete_all_filters') }}?
                    <v-spacer />
                    <v-icon end color="success" @click.stop="clear">mdi-check</v-icon>
                    <v-icon end color="error" @click.stop="mobileButtonInfo = !mobileButtonInfo"> mdi-close </v-icon>
                </div>
                <template v-slot:close>
                    <v-icon
                        v-show="mobileButtonInfo"
                        end
                        color="white"
                        @click.stop="mobileButtonInfo = !mobileButtonInfo"
                    >
                        mdi-close
                    </v-icon>
                </template>
            </v-alert>
        </client-only>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Emit} from 'vue-facing-decorator'

    @Component
    export class FilteredMobileButton extends Vue {
        mobileButtonInfo = true

        @Prop({required: true}) count
        @Prop({required: true}) visible

        @Emit()
        clearFilters() {}

        @Emit()
        changeMode() {}

        clear() {
            this.clearFilters()
            this.mobileButtonInfo = true
        }
    }

    export default FilteredMobileButton
</script>

<style scoped>
    :deep(.v-alert__wrapper) {
        width: 100%;
    }
</style>
